

import { useState, useEffect } from 'react';
import axios from 'axios';
import { Link as RouterLink, Redirect, 
  // useNavigate 
} from 'react-router-dom';
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import {
  Box,
  Container,
    Button
} from '@material-ui/core';

import sampleData from 'src/utils/sampleData.json';


//Redux
import { useDispatch, useSelector } from "react-redux";

//Components
import PaymentCard from 'src/materials/PaymentCard';
import { SET_BACKBTN } from 'src/redux/actions/types';

const Login = (props) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [selected, setSelect] = useState(null);
  const dispatch = useDispatch();

// const navigate = useNavigate();
const { isLoggedIn, user } = useSelector(state => state.auth);


useEffect(() => {
  dispatch({
    type: SET_BACKBTN,
    payload: '/app/dashboard'
  })
}, [])



  return (
    <>
      <Helmet>
        <title>Login | 
          {/* Transac */}
          GCheck
          </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          // flexDirection: 'column',
          height: '100%',
          width: '400px',
          margin: 'auto'
        }}
      >
        {sampleData.payments.map((a, index) => {
          console.log(selected === index)
          return <PaymentCard key={index} index={index} setClick={(e) => setSelect(e !== selected ? e : null)} data={a} open={index === selected}/>
        })}
            
      </Box>
    </>
  );
};

export default Login;

